import { render } from "./CheckAcceptance.vue?vue&type=template&id=550bddd4&scoped=true"
import script from "./CheckAcceptance.vue?vue&type=script&lang=js"
export * from "./CheckAcceptance.vue?vue&type=script&lang=js"

import "./CheckAcceptance.vue?vue&type=style&index=0&id=550bddd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550bddd4"]])

export default __exports__